var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-table",
    _vm._g(
      _vm._b(
        {
          ref: "table",
          scopedSlots: _vm._u(
            [
              {
                key: "table-busy",
                fn: function () {
                  return [
                    _c("div", { staticClass: "text-center my-2" }, [
                      _vm.isLoading
                        ? _c("strong", [
                            _c("i", {
                              staticClass: "fas fa-fw fa-circle-notch fa-spin",
                            }),
                          ])
                        : _c("div", { staticClass: "d-flex text-danger" }, [
                            _c("div", { staticClass: "ml-auto px-2" }, [
                              _c("i", {
                                staticClass:
                                  "fas fa-fw fa-exclamation-triangle",
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mr-auto pr-2 text-left" },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm._f("trans")(_vm.errorText))
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "head()",
                fn: function (row) {
                  return [
                    _c("div", { staticClass: "sort-header" }, [
                      _vm._v("\n      " + _vm._s(row.label) + "\n      "),
                      _c("span", { staticClass: "sort-container" }, [
                        _c("i", {
                          staticClass: "fas fa-fw fa-sort sort-none text-light",
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "fas fa-fw fa-sort-up sort-asc text-primary",
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "fas fa-fw fa-sort-down sort-desc text-primary",
                        }),
                      ]),
                    ]),
                  ]
                },
              },
              _vm._l(_vm.$scopedSlots, function (_, slot) {
                return {
                  key: slot,
                  fn: function (scope) {
                    return [_vm._t(slot, null, null, scope)]
                  },
                }
              }),
            ],
            null,
            true
          ),
        },
        "b-table",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }